<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      overlay-color="rgba(39, 50, 64)"
      overlay-opacity="0.6"
      :fullscreen="$vuetify.breakpoint.xs ? true : false"
    >
      <v-card>
        <v-card-title class="header info">
          {{ $t('packs.upgradePack') }}
        </v-card-title>
        <v-card-text class="mt-4">
          {{ $t('packs.needUpgrade') }}
        </v-card-text>
        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            class="success"
            @click="$router.push('/subscriptions')"
          >
            {{ $t('packs.upgradePack') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'HelperUpgradePlan',
  data: () => ({
    dialog: false,
  }),
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
